import { render, staticRenderFns } from "./EventListsComponent.vue?vue&type=template&id=6111d2cb"
import script from "./EventListsComponent.vue?vue&type=script&lang=js"
export * from "./EventListsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports